import RatingStars from "./RatingStars";

export default RatingStars;
